import { render } from "./UCCodeScanner.vue?vue&type=template&id=2b8e6e75&scoped=true"
import script from "./UCCodeScanner.vue?vue&type=script&lang=js"
export * from "./UCCodeScanner.vue?vue&type=script&lang=js"

import "./UCCodeScanner.vue?vue&type=style&index=0&id=2b8e6e75&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8e6e75"]])

export default __exports__